import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/home";
import "../src/css/globalStyles.sass";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/guru-cs" replace />} />

        <Route path="/guru-cs" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;